import api, { unwrap } from '../client';

export const listPeople        = (tenantId, year) => unwrap(api.get(`/tdabc/people/${tenantId}`, { params: year ? { year } : {} }));
export const createPerson      = (tenantId, data)  => unwrap(api.post(`/tdabc/people/${tenantId}`, data));
export const patchPerson       = (tenantId, id, patch, year) => unwrap(api.patch(`/tdabc/people/${tenantId}/${id}`, patch, { params: year ? { year } : {} }));
export const deletePerson      = (tenantId, id)    => unwrap(api.delete(`/tdabc/people/${tenantId}/${id}`));

export const listCostPools     = (tenantId)        => unwrap(api.get(`/tdabc/cost-pools/${tenantId}`));
// Taux employeur TDABC retiré → 0 (le coût employeur réel vient de People → Charges sociales).
export const getTotalRate      = () => Promise.resolve({ data: 0, error: null });
